import type { Logger } from 'pino';
import pino from 'pino';
import { config } from '../config';

const writeFn = (level: string) => (o: object) => {
  const logObj = o as Record<string, unknown> & { msg?: string; module?: string };
  const consoleFn = level === 'fatal' ? 'error' : level;
  const method = consoleFn as keyof Pick<
    Console,
    'debug' | 'info' | 'warn' | 'error' | 'trace'
  >;
  const module = logObj.module ?? 'unknown';
  console[method](`[${module}]`, JSON.stringify(logObj));
};

const logger = pino({
  level: config.env === 'production' ? 'info' : 'debug',
  browser: {
    asObject: true,
    write: {
      debug: writeFn('debug'),
      info: writeFn('info'),
      warn: writeFn('warn'),
      error: writeFn('error'),
      fatal: writeFn('fatal'),
    },
  },
});

export { logger };
export type { Logger };
